module.exports = __webpack_public_path__ + "img/messiahcomplex.8dac074a.svg";